import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import CategoryApi from '../../../lib/api/category/CategoryApi';
import { CATEGORY } from '../../../constants/queryKeys';

/**
 * 서브 카테고리 리스트를 가져오는 query hook
 * @return {UseQueryResult<AxiosResponse<any>, unknown>}
 */
const useCategoryDetail = (options) => {
  const { id } = useParams();

  return useQuery([...CATEGORY.SUB_CATEGORY_LIST, id], () => CategoryApi.getSubCategoryList(id), {
    ...options,
  });
};

export default useCategoryDetail;
